import type { RemoteCacheClientOperationResult } from '@ms-cloudpack/remote-cache';

function isFulfilled<T>(result: PromiseSettledResult<T>): result is PromiseFulfilledResult<T> {
  return result.status === 'fulfilled';
}

export function getRemoteCachePromiseResultCounts(
  promiseResults: PromiseSettledResult<RemoteCacheClientOperationResult>[],
): Record<RemoteCacheClientOperationResult | 'failed', number> {
  const counts: Record<RemoteCacheClientOperationResult | 'failed', number> = {
    'already-exist': 0,
    'not-found': 0,
    success: 0,
    failed: 0,
  };

  for (const promiseResult of promiseResults) {
    if (isFulfilled(promiseResult)) {
      counts[promiseResult.value]++;
    } else {
      counts.failed++;
    }
  }

  return counts;
}
